import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BaseComponent } from '../../shared/base-components/base.component';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { Directive } from '@angular/core';

@Directive()
export abstract class CustomerModalBaseComponent extends BaseComponent {
    public showButtonLoading = false;

    constructor(public modalService: MvdModalService) {
        super();
    }

    endDateRecordConfirmation(itemType: string): Observable<any> {
        return this.modalService.confirm().title('Warning')
            .body('Deleting ' + itemType + ' will remove it from the active customer record view. This information will remain within customer record history.\n\nAre you sure you want to delete this information?')
            .okBtn('Delete').cancelBtn('Cancel')
            .open().afterClosed()
            .pipe(filter(result => !!result));
    }

    protected dateToString(value) {
        if (value != null) {
            var d = new Date(value);

            if (d) {
                return (d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear());
            } else {
                return value;
            }
        }

        return null;
    }

    public cancel() {}
}
